var _circle, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuestPanelIncompleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F4F6F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 27.1852C11 30.5324 15.2575 31.4 20.3 31.4C25.3157 31.4 29.6 30.5632 29.6 27.2148C29.6 23.8676 25.3437 23 20.3 23C15.2843 23 11 23.8368 11 27.1852Z",
    fill: "url(#paint0_radial_8623_6716)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.2002C23.3311 21.2002 26 18.5299 26 15.1996C26 11.8694 23.3311 9.2002 20 9.2002C16.6701 9.2002 14 11.8694 14 15.1996C14 18.5299 16.6701 21.2002 20 21.2002Z",
    fill: "url(#paint1_radial_8623_6716)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8623_6716",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.3 27.2) rotate(90) scale(4.2 9.3)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ADC7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8623_6716",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20 15.2002) rotate(90) scale(6)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC2D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8ADC7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestPanelIncompleteIcon);
export default __webpack_public_path__ + "static/media/guest-panel-incomplete-icon.f5057d1104196b0d12c72e446dacf341.svg";
export { ForwardRef as ReactComponent };